import axios from 'axios';
import { SourceBatchModel } from '../Models/SourceBatchModel';

const getSourceBatch = (batch: SourceBatchModel) => axios.post(`classifications/categories/${batch.categoriesId[0]}/sources`, batch);
const insertSourceBatch = (batch: SourceBatchModel) => axios.post(`classifications/categories/${batch.categoriesId[0]}/sources/insert-batch`, batch);
const deleteSourceBatch = (batch: SourceBatchModel) => axios.patch(`classifications/categories/${batch.categoriesId[0]}/sources/delete-batch`, batch);

export default {
    getSourceBatch,
    insertSourceBatch,
    deleteSourceBatch
};